import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  SbeSmsApiService,
  type MemberPickerExchangeResultDto,
  type MemberPickerSessionCreatedDto,
} from '@sbe-spinoff-client/sbe-sms-api';

/**
 * schoolbell-e 멤버 피커 팝업(2026-08-03 플랜) RP 백엔드(sbe-sms-api) 호출 facade — orval 이
 * 만든 `SbeSmsApiService`를 controller suffix 없는 의미명으로 wrap한다(MessagesApiService와
 * 동일 패턴). `apps/sbe-sms/api/src/features/orgs/member-picker.controller.ts` 참조.
 *
 * 2026-08-20까지는 이 엔드포인트가 OrgsModule 소속이라는 이유로 openapi-export.task.ts의
 * SessionService 테스트 스텁이 onModuleInit에서 깨져 openapi.json에서 통째로 빠져 있었다
 * (openapi-export.task.ts의 SessionService/PermissionModule/SCHOOLBELL_*_SERVICE/
 * SpinoffProviderFederationModule 스텁·배선 보강으로 해소 — orgs.module.ts의 실제 배선은 항상
 * 정상이었고, 테스트 하네스 갭이었다). 이제 orval codegen 대상이라 손으로 HttpClient를 호출하지
 * 않는다.
 */
@Injectable({ providedIn: 'root' })
export class MemberPickerApiService {
  private readonly api = inject(SbeSmsApiService);

  createSession(orgId: string): Promise<MemberPickerSessionCreatedDto> {
    return firstValueFrom(this.api.memberPickerControllerCreateSession(orgId));
  }

  exchangeSession(code: string): Promise<MemberPickerExchangeResultDto> {
    return firstValueFrom(this.api.memberPickerControllerExchangeSession(code));
  }
}
